


















































import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject} from 'vue-property-decorator'

import SadNavigation from './components/SadNavigation/SadNavigation.vue'
import SadNavbar from './components/SadNavbar/SadNavbar.vue'
import LoginForm from '@/account/login-form/login-form.vue'
import TranslationService from '@/locale/translation.service'
import ReferentielService from '@/shared/referentiel/referentiel.service'
import DossierService from '@/shared/dossier/dossier.service'

@Component({
  components: {
    SadNavigation,
    SadNavbar,
    'login-form': LoginForm
  }
})
export default class App extends Vue {
  @Inject('translationService') private translationService: () => TranslationService
  @Inject('referentielService') private referentielService: () => ReferentielService
  @Inject('dossierService') private dossierService: () => DossierService
  private currentLanguage = this.$store.getters.currentLanguage

  created() {
    this.translationService().refreshTranslation(this.currentLanguage)
    this.referentielService().loadReferentiel()
  }
}
